import React, {useState} from 'react';
import {Button, Form, Input, Modal} from 'antd';
import Pallet from "../../http_request/Model/pallet/Pallet";
import ResultComponent from "../../microComponents/modals/ResultComponent";
import {useDispatch} from "react-redux";
import {getAgainHandler} from "../../store/TableRedux/TableRedux";

const RebuildCompleteModal = ({rowData}) => {
    const dispatch = useDispatch();

    const [form] = Form.useForm();
    const [code, setCode] = useState();
    const [openResult, setOpenResult] = useState(false);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const showModal = () => {
        setOpen(true);
    };

    const handleCancel = () => {
        setOpen(false);
    };


    const onFinish = (values) => {


        Pallet.request({
            beforeSend: () => {
                setLoading(true)
            }, success: (result) => {
                setCode(result)
                setOpenResult(true)
                dispatch(getAgainHandler());
                handleCancel()

            }, final: () => {
                setLoading(false)
            }


        }).addParams({pid: rowData.palletId, numberPerPallet: values.numberPerPallet}).reconstruct()
    };

    return (<>
        <button onClick={showModal} className='defBtn blueBtn'> تکمیل بازسازی</button>
        <ResultComponent openResult={openResult} setOpenResult={setOpenResult}
                         status="success"
                         title={`کد تایید: ${code}`}
                         extra={[

                             <Button key="buy" onClick={() => {
                                 setOpenResult(false)
                             }}>بستن</Button>,
                         ]}

        />
        <Modal
            open={open}
            title=" تکمیل بازسازی"
            onCancel={handleCancel}
            footer={[<Button key="back" className='defBtn   redBtn ' onClick={handleCancel}>
                انصراف
            </Button>, <Button className='defBtn blueBtn' type="primary" htmlType="submit" loading={loading}
                               onClick={() => {
                                   form.submit()
                               }}>
                ثبت
            </Button>]}
        >


            <Form
                name="basic"
                layout='vertical'
                form={form}
                onFinish={onFinish}
                autoComplete="off"
            >
                <Form.Item
                    name="numberPerPallet"
                    label="تعداد در پالت"
                    rules={[{
                        required: true, message: 'لطفا تعداد در پالت را وارد کنید!',
                    }, {
                        message: `حداکثر تعداد ${rowData?.numberPerPallet} عدد می باشد.`, validator: (_, value) => {
                            if (value > 0 && value <= rowData?.numberPerPallet) {
                                return Promise.resolve();
                            } else {
                                return Promise.reject(`حداکثر تعداد ${rowData?.numberPerPallet} عدد می باشد.`,);
                            }
                        }
                    }


                    ]}

                >
                    <Input type='number'/>
                </Form.Item>


            </Form>


        </Modal>
    </>);
};
export default RebuildCompleteModal;
